"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const Subject_1 = require("rxjs/Subject");
const rich_text_state_1 = require("./model/rich-text-state");
let RichTextComponent = class RichTextComponent {
    constructor(communicationService) {
        this.communicationService = communicationService;
        this.initialized = false;
        this.stateChange = new core_1.EventEmitter();
        this.destroy$ = new Subject_1.Subject();
    }
    set state(state) {
        if (state !== this.richTextStateEmitted || !this.richTextStateEmitted) {
            this.richTextState = rich_text_state_1.RichTextState.fromJSON(state);
            this._richTextTemplate = this.richTextState.state;
        }
    }
    onTemplateChange() {
        this.emitState();
    }
    ngAfterViewInit() {
        this.initialized = true;
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    emitState() {
        this.richTextStateEmitted = this.richTextState.toJSON();
        // escape forward slashes
        this.richTextStateEmitted.state && (this.richTextStateEmitted.state = this.richTextStateEmitted.state.replaceAll("/", "\\/"));
        this.stateChange.emit(this.richTextStateEmitted);
        this.preview();
    }
    preview() {
        let communicationData = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW);
        this.communicationService.parentSubject.next(communicationData);
    }
    get richTextTemplate() {
        return this._richTextTemplate;
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RichTextComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], RichTextComponent.prototype, "state", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], RichTextComponent.prototype, "stateChange", void 0);
RichTextComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-rich-text',
        template: require('./rich-text.component.html'),
        styles: [require('./rich-text.component.css')]
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: `<sis-rich-text [id]="controlId" [state]='%{state}' (stateChange)='%{stateChange}'></sis-rich-text>`,
    }),
    __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService])
], RichTextComponent);
exports.RichTextComponent = RichTextComponent;
//# sourceMappingURL=rich-text.component.js.map